import React, { useEffect } from 'react';
import Loader from '../Layout/Loader';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const Callback = () => {

  const { user } = useAuth0();
  const navigate = useNavigate()
  useEffect(() => {
    if (user) {
      localStorage.setItem('auth0_profile', JSON.stringify(user));
   
      // Redirect to the desired page after setting local storage
      navigate(`${process.env.PUBLIC_URL}/home`);
    }
  }, [user, navigate]);

  return (
    <div>
      <Loader />
    </div>
  );

};

export default Callback;